import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

// Importing forms module
import { FormsModule } from '@angular/forms'

// Configure firebase.
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';

// Importing the environment config file for the firebase configuration.
import { environment } from 'src/environments/environment';

import { StudentsComponent } from './students/students.component';
import { StudentComponent } from './students/student/student.component';
import { StudentListComponent } from './students/student-list/student-list.component';

// Importing the student service.
import { StudentService } from './shared/student.service';
import { ProductService } from './shared/product.service';
import { ProductListComponent } from './students/product-list/product-list.component';
import { ProductComponent } from './students/product/product.component';
import { OnlyNumberDirective } from './shared/only-number.directive';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    StudentsComponent,
    StudentComponent,
    StudentListComponent,
    ProductListComponent,
    ProductComponent,
    OnlyNumberDirective
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    FormsModule
  ],
  providers: [StudentService, ProductService, DatePipe],
  bootstrap: [AppComponent]
})

export class AppModule { }
